<div class="text-center">
  <h1 class="">Thank you!</h1>
</div>

<p class="text-center">
  You've successfully submitted your application.
</p>
<p class="text-center">
  Please login to ACE to check the <a [routerLink]="['/app/message-center']" target="_blank">Message Center</a> frequently for
  notifications.
</p>

<mat-divider></mat-divider>

<div class="feedback-section">
  <p class="feedback-prompt text-center">How would you rate your experience with the ACE system?</p>

  <div class="stars-container" (mouseleave)="onStarLeave()">
    <button mat-icon-button
            *ngFor="let star of stars"
            (click)="setRating(star)"
            (mouseenter)="onStarHover(star)"
            [attr.aria-label]="star + ' star' + (star > 1 ? 's' : '')"
            class="star-button">
      <mat-icon>{{ (hoverRating || rating) >= star ? 'star' : 'star_border' }}</mat-icon>
    </button>
  </div>

  <div class="comment-section">
    <label class="comment-label">Any feedback? (optional)</label>
    <textarea
      [(ngModel)]="comment"
      maxlength="500"
      rows="3"
      class="comment-textarea"
      placeholder="Tell us about your experience...">
    </textarea>
    <div class="char-counter">{{ comment.length }} / 500</div>
  </div>
</div>

<mat-dialog-actions align="center">
  <button mat-raised-button color="primary" [disabled]="!rating" (click)="submitFeedback()">Submit Feedback</button>
  <button mat-button (click)="skip()">Skip</button>
</mat-dialog-actions>
